import React from "react";
import { ShieldAlert } from "lucide-react";

export function Disclaimer({ className = "", short = false }) {
  return (
    <div
      data-testid="finance-disclaimer"
      className={`flex items-start gap-2.5 text-[11px] leading-relaxed text-mutedText/90 ${className}`}
    >
      <ShieldAlert size={14} className="mt-0.5 shrink-0 text-sand" />
      <p>
        {short
          ? "Indicative only. Not credit advice. Subject to lender approval."
          : "These figures are indicative only and provided to help the conversation. They are not credit advice, not an offer of finance, and are subject to full assessment and lender approval. Actual borrowing capacity, rates and costs will vary."}
      </p>
    </div>
  );
}
